<template>
  <div class="rate-info">
    <div class="rate-info__amenities">
      <refundability
        class="rate-info__refundable"
        :cancellation="rate.refundable_before"
      />
      <div
        class="rate-info__amenity"
        v-for="(amenity, amenity_index) in rate.amenities"
        :key="_uid+'_amenity_'+amenity_index"
      >
        <amenity
          :item="amenity"
          :type="'rates'"
        />
      </div>
    </div>
    <div class="rate-info__details">
      <rate-details
        :rate="rate"
      />
    </div>
  </div>
</template>

<script>
import Refundability from '@liveeps/components/atoms/refundability'
import Amenity from "@liveeps/components/atoms/amenity"
import RateDetails from "@liveeps/components/atoms/rate-details"

export default {
  name: 'rate-info',

  components: {
    'refundability': Refundability,
    'amenity': Amenity,
    'rate-details': RateDetails,
  },

  props: {
    rate: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .rate-info {
    color: $gray-600;
    font-size: $font-size-md;
    padding-left: $grid-gutter-width / 3;
    border-left: 1px solid $gray-400;

    &__amenities {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &__refundable {
      margin-right: $grid-gutter-width / 3;
      margin-bottom: $grid-gutter-width / 6;
    }

    &__amenity {
      margin-right: $grid-gutter-width / 4;
      margin-bottom: $grid-gutter-width / 6;

      &:last-child {
        margin-right: 0;
      }
    }

    &__details {
      display: none;

      @include media-breakpoint-up(md){
        display: block;
      }
    }
  }

</style>